export const appraisalOptions = [
  { key: "valuation", value: "valuation", text: "Valuation" },
  {
    key: "insurance_coverage",
    value: "insurance_coverage",
    text: "Insurance Coverage",
  },
  {
    key: "charitable_contribution",
    value: "charitable_contribution",
    text: "Charitable Contribution",
  },
  {
    key: "estate_inheritance_taxes",
    value: "estate_inheritance_taxes",
    text: "Estate or Inheritance Taxes",
  },
  { key: "estate_planning", value: "estate_planning", text: "Estate Planning" },
  {
    key: "equitable_distribution",
    value: "equitable_distribution",
    text: "Equitable Distribution",
  },
  { key: "damage_loss", value: "damage_loss", text: "Damage/Loss" },
]

export const basicBenefits = [
  {
    enabled: true,
    header: "Inventory Management",
    content:
      "Document the pieces you own, the artists you collect, and the galleries you use to build your collection.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Mobile Applications",
    content: "Access your collection anywhere, anytime.",
    icon: "check",
  },
  {
    enabled: false,
    header: "Auction Alerts",
    content: `Receive alerts detailing upcoming auctions featuring works by artists you collect and follow.`,
    icon: "minus",
  },
  {
    enabled: false,
    header: "Price Database",
    content: `Access ArtCollection.io's auction price database, including estimates, realized prices, dates, and venues.`,
    icon: "minus",
  },
  {
    enabled: false,
    header: "Follow Artists",
    content: `Analyze an individual artist's performance over time according to various metrics.`,
    icon: "minus",
  },
  {
    enabled: false,
    header: "Peformance Analytics",
    content: `Analyze an individual artist's performance over time according to various metrics.`,
    icon: "minus",
  },
]

export const premiumBenefits = [
  {
    enabled: true,
    header: "Inventory Management",
    content:
      "Document the pieces you own, the artists you collect, and the galleries you use to build your collection.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Mobile Applications",
    content: "Access your collection anywhere, anytime.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Auction Alerts",
    content: `Receive alerts detailing upcoming auctions featuring works by artists you collect and follow.`,
    icon: "plus",
  },
  {
    enabled: true,
    header: "Price Database",
    content: `Access ArtCollection.io's auction price database, including estimates, realized prices, dates, and venues.`,
    icon: "plus",
  },
  {
    enabled: false,
    header: "Follow Artists",
    content: `In addition to the artists you collect, stay up to date on the ones you'd like to hear more about`,
    icon: "minus",
  },
  {
    enabled: false,
    header: "Performance Analytics",
    content: `Analyze an individual artist's performance over time according to various metrics.`,
    icon: "minus",
  },
]

export const proBenefits = [
  {
    enabled: true,
    header: "Inventory Management",
    content:
      "Document the pieces you own, the artists you collect, and the galleries you use to build your collection.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Mobile Applications",
    content: "Access your collection anywhere, anytime.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Auction Alerts",
    content: `Receive alerts detailing upcoming auctions featuring works by artists you collect and follow.`,
    icon: "check",
  },
  {
    enabled: true,
    header: "Price Database",
    content: `Access ArtCollection.io's auction price database, including estimates, realized prices, dates, and venues.`,
    icon: "check",
  },
  {
    enabled: true,
    header: "Follow Artists",
    content: `In addition to the artists you collect, stay up to date on the ones you'd like to hear more about`,
    icon: "plus",
  },
  {
    enabled: true,
    header: "Performance Analytics",
    content: `Analyze an individual artist's performance over time according to various metrics.`,
    icon: "plus",
  },
]
export const businessBenefits = [
  {
    enabled: true,
    header: "Manage Multiple Accounts",
    content:
      "Document the pieces you own, the artists you collect, and the galleries you use to build your collection.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Inventory Management",
    content:
      "Document the pieces you own, the artists you collect, and the galleries you use to build your collection.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Mobile Applications",
    content: "Access your collection anywhere, anytime.",
    icon: "check",
  },
  {
    enabled: true,
    header: "Auction Alerts",
    content: `Receive alerts detailing upcoming auctions featuring works by artists you collect and follow.`,
    icon: "check",
  },
  {
    enabled: true,
    header: "Price Database",
    content: `Access ArtCollection.io's auction price database, including estimates, realized prices, dates, and venues.`,
    icon: "check",
  },
  {
    enabled: true,
    header: "Follow Artists",
    content: `In addition to the artists you collect, stay up to date on the ones you'd like to hear more about`,
    icon: "plus",
  },
  {
    enabled: true,
    header: "Performance Analytics",
    content: `Analyze an individual artist's performance over time according to various metrics.`,
    icon: "plus",
  },
]
